import React, { FC, useState } from "react";
import { IDeal } from "../../../../models/sidemenu";
import HtmlRender from "../../../UI/HtmlRender";
import "./deal.scss";
import { IMAGE_URL_CONFIG, URLS } from "../../../../constants/url";
import { downloadFile } from "../../../../utils/helper";

interface IDealProps {
  data: IDeal;
}

const Deal: FC<IDealProps> = ({ data }) => {
  const errorHandler = (event: any) => {
    event.target.src = URLS.ERROR_IMAGE;
  };
  return (
    <div className="deals list-content">
      <div className="container">
        <div className="row">
          <div className="col-md-12 col-12">
            <div className="media">
              <div className="list_poster">
                <img
                  className="align-self-start"
                  src={data.deal_image}
                  alt={data.title}
                  title={data.title}
                  onError={errorHandler}
                />
              </div>
              <div className="media-body ">
                <div className="row">
                  <div className="col-md-12">
                    <h3 className="deal-head">{data.title}</h3>
                    <HtmlRender
                      {...{ className: "description" }}
                      content={data.description}
                    />
                    {data.content ? <HtmlRender
                      {...{ className: "description" }}
                      content={data.content}
                    /> : null}
                    {data?.menus && data?.menus?.length > 0 ? <div>
                      {data.menus.map((menu: any) => menu.name ? (
                        <a type="button" className="downloadLink" onClick={() => downloadFile(`${URLS.CLOUDFRONT_URL}/${IMAGE_URL_CONFIG.FILE_PATH}/${menu.id}.${menu.extension}`, 'blank')}>
                          {menu.name}
                        </a>
                      ) : null)
                      }</div> : null}
                    {data?.vouchers && data?.vouchers?.length > 0 ? <div className="my-3">
                      {data.vouchers.map((voucher: any) => voucher.name ? (
                        <a className="downloadLink" onClick={() => downloadFile(`${URLS.CLOUDFRONT_URL}/${IMAGE_URL_CONFIG.FILE_PATH}/${voucher.id}.${voucher.extension}`, 'blank')}>
                          {voucher.name}
                        </a>
                      ) : null)
                      }
                    </div> : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Deal;
